module.exports = __webpack_public_path__ + "static/media/protects.6126e236.mp3";